import { Component } from '@angular/core';
import { DropDownItem } from 'app/interfaces/items/dropDownItem';
import { ExposedSubmitOtherFundsApplicationRes } from 'app/interfaces/responses/Exposed/exposedSubmitOtherFundsApplicationRes';

@Component({
    selector: 'app-pension-other-funds',
    templateUrl: './pension-other-funds.component.html',
    styleUrls: ['./pension-other-funds.component.scss'],
})
export class PensionOtherFundsComponent {
    readonly retirementApplicationType = 'PensionApplication_OF';
    readonly spouseApplicationType = 'SpousePensionApplication_OF';

    applicationTypeOptions: DropDownItem[] = [
        { value: this.retirementApplicationType, viewValue: 'Eftirlaunaumsókn' },
        { value: this.spouseApplicationType, viewValue: 'Makalífeyrisumsókn' },
    ];

    selectedApplicationType = this.retirementApplicationType;
    submitResult: ExposedSubmitOtherFundsApplicationRes | null = null;

    switchApplicationType(applicationType: string): void {
        this.selectedApplicationType = applicationType;
        this.submitResult = null;
    }

    onSubmitted(result: ExposedSubmitOtherFundsApplicationRes): void {
        this.submitResult = result;
    }

    clearResult(): void {
        this.submitResult = null;
    }
}
